import React from 'react';
import { usePushNotifications, useSendbirdConnection, useSendbirdSessionHandler } from 'app/_modules/chat';

export const PushNotificationInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useSendbirdSessionHandler();
  usePushNotifications();
  useSendbirdConnection();
  
  return <>{children}</>;
};
